
import request from '../request'

const URL = {
  findPagePartIsFine: '/advertisement/findBannerListByReceive', // 资讯头新闻
  findOrgByReceive: 'org/findOrgByLoginInfo', // 组织成员
  findActivityByReceive: 'orgActivity/findActivityListByReceive', // 精选活动
  findMemorabiliaListByReceive: '/memorabilia/findMemorabiliaListByReceive', // 历史上的今天
  findServiceContent: 'orgEnchiridion/findEnchiridionListByReceive', // 服务内容
  findServiceTab: '/orgEnchiridion/findEnchiridionType', // 服务标题
  findByIdService: '/orgEnchiridion/findById', // 服务详情
  findByIdAdvertisement: '/advertisement/findById', // 精彩专题详情
  findByIdActivity: '/orgActivity/findById', // 精选活动详情
  communityContacts: '/org/findOneNowLoginUser' // 社区的社区联系人
}

const news = {
  /**
  * 资讯头新闻
  * @param {object} reqData  请求参数
  */
  findPagePartIsFine (reqData) {
    return request.put(URL.findPagePartIsFine, reqData)
  },
  /**
  * 历史上的今天
  */
  findMemorabiliaListByReceive (reqData) {
    return request.put(URL.findMemorabiliaListByReceive, reqData)
  },
  // 精选活动
  findActivityByReceive (reqData) {
    return request.put(URL.findActivityByReceive, reqData)
  },
  // 组织成员
  findOrgByReceive () {
    return request.get(`${URL.findOrgByReceive}?_dt=${new Date().getTime()}`)
  },
  // 服务详情
  findServiceContent (reqData) {
    return request.put(URL.findServiceContent, reqData)
  },
  // 服务标题
  findServiceTab () {
    return request.get(`${URL.findServiceTab}?_dt=${new Date().getTime()}`)
  },
  findByIdService (id) {
    return request.get(`${URL.findByIdService}/${id}?_dt=${new Date().getTime()}`)
  },
  findByIdAdvertisement (id) {
    return request.get(`${URL.findByIdAdvertisement}/${id}?_dt=${new Date().getTime()}`)
  },
  findByIdActivity (id) {
    return request.get(`${URL.findByIdActivity}/${id}?_dt=${new Date().getTime()}`)
  },
  // 社区的社区联系人
  communityContacts () {
    return request.get(`${URL.communityContacts}?_dt=${new Date().getTime()}`)
  },
}
export default news
